import React from 'react'
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar';
import '../../css/common.css';
import '../../css/notice.css';
import { ApiService } from '../../services/apiService';
import { Buffer } from 'buffer';

export default function NoticeForm() {
	// let {id} = useParams();
	const navigate = useNavigate();
	let props = useLocation();
	const authData = useSelector(state => state.auth);
	const [title, setTitle] = useState(props.state === null ? "" : props.state.title);
	const [content, setContent] = useState(props.state === null ? "" : Buffer.from(props.state.body, "base64").toString('utf8'));
	let boardData = {};

	const insertHandle = async (e) => {
		e.preventDefault();
		// const base64EncodedText = Buffer.from(content, "utf8").toString('base64');
		boardData = {
			"title" : title,
			"body" : Buffer.from(content, "utf8").toString('base64'),
			"admin_id" : authData.user.email,
		}

		try {
			await ApiService.insertBoard(boardData);
			navigate("/notice");
		} catch (error) {
			console.log('NoticeForm - insertHandle - error :: ', error)
		} 
	}

	const modifyHandle = async (e) => {
		e.preventDefault();
		
		boardData = {
			"title" : title,
			"body" : Buffer.from(content, "utf8").toString('base64'),
		}
		try {
			await ApiService.modifyBoard(boardData, props.state.id);
			navigate("/notice");
		} catch (error) {
			console.log('NoticeForm - modifyHandle - error :: ', error)
		}
	}

	const changeHandleTitle = (e) => {
		setTitle(e.target.value);
	}

	const changeHandleBody = (e) => {
		setContent(e.target.value);
	}
	
	return (
		<div className="containList">
			{ (props.state !== null) ? (
				<BreadCrumbBar menu="공지사항" smenu="공지사항 수정"/>
				) : (
					<BreadCrumbBar menu="공지사항" smenu="공지사항 등록"/>
				)
			}
			<form className="boardform">
				<div className="textBox">
					<label htmlFor="title" className="textLabel">제목</label>
					{ (props.state !== null) ? (<input type="text" id="title" defaultValue={title} onChange={changeHandleTitle}></input>) 
					: (<input type="text" id="title" onChange={changeHandleTitle}></input>)}
				</div>

				<div className="textBox">
					<label htmlFor="content" id="contentLabel" className="textareaLabel">내용</label>
					{ (props.state !== null) ? (<textarea id="content" value={content} onChange={changeHandleBody}>{content}</textarea>) 
					: (<textarea id="content" value={content} onChange={changeHandleBody}>{content}</textarea>)}
				</div>

				<div className="buttonBox">
					<button className="listbutton" onClick={(e) => {e.preventDefault(); navigate("/notice")}}>목록</button>
					{ props.state !== null ? (
						<>
							<button className="writebutton" onClick={modifyHandle}>수정</button>
						</>
					): (
						<>
							<button className="writebutton" onClick={insertHandle}>등록</button>
						</>
					)}
				</div>
			</form>

		</div>
	)
}
